import Axios from '@/services/axios-instance/axios.service';

class ApplicationService {
  async getApplicationDetails() {
    const { data } = await Axios.get('/application/details');
    return data;
  }
  async updateApplicationDetails(req) {
    const { data } = await Axios.post('/application/details-update', req);
    return data;
  }
  async getOverview() {
    const { data } = await Axios.get('/application/overview');
    return data;
  }
  async getFAQ() {
    const { data } = await Axios.get('/application/faq');
    return data;
  }
  async getLatestComments(req) {
    const { data } = await Axios.post('/application/latest-comments', req);
    return data;
  }
  async getLatestComment(req) {
    const { data } = await Axios.post('/application/latest-comment', req);
    return data;
  }
  async createNotes(req) {
    const { data } = await Axios.post('/application/create-notes', req);
    return data;
  }
  async initCheckYourEntitlement() {
    const { data } = await Axios.get('/application/init-check-your-entitlement');
    return data;
  }
  async saveTaxYearAllocation(req) {
    const { data } = await Axios.post('/application/save-tax-year-allocation', req);
    return data;
  }
  async editExtraYears(req) {
    const { data } = await Axios.post('/application/edit-extra-years', req);
    return data;
  }
  async getRequestCheck() {
    const { data } = await Axios.get('/application/get-request-check');
    return data;
  }
  async saveRequestCheck(req) {
    const { data } = await Axios.post('/application/save-request-check', req);
    return data;
  }
  async getBillingInfo() {
    const { data } = await Axios.get('/application/billing-info');
    return data;
  }
  async tickLastEntitlementOption(req) {
    const { data } = await Axios.post('/application/tick-last-entitlement-option', req);
    return data;
  }
  async getReceipt(req) {
    const { data } = await Axios.post('/application/get-receipt', req);
    return data;
  }
  async updatePaymentMethodBillingPage(req) {
    const { data } = await Axios.post('/application/update-payment-method-billing-page', req);
    return data;
  }
}

export default new ApplicationService();
